// extracted by mini-css-extract-plugin
export default {"mainWrapper":"home_mainWrapper__sEMCS"};